import React from "react";
import { motion } from "framer-motion";
import { FadeUp, SectionLabel } from "./Motion";
import { useContent } from "../context/ContentContext";

const Achievements = () => {
  const { content } = useContent();
  const stats = content.stats || [];
  const milestones = content.milestones || [];
  return (
    <section id="achievements" className="relative py-28 md:py-40" data-testid="achievements-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <FadeUp><SectionLabel num="03">By the numbers</SectionLabel></FadeUp>
        <FadeUp delay={0.05}>
          <h2 className="mt-8 font-display text-3xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-[-0.02em] text-black max-w-4xl">
            Two decades. <span className="font-semibold">One uncompromising standard.</span>
          </h2>
        </FadeUp>

        <div className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 border-t border-black/10" data-testid="stats-grid">
          {stats.map((s, i) => (
            <motion.div key={s.label + i}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`py-10 md:py-14 px-2 md:px-6 ${i < 3 ? "md:border-r border-black/10" : ""} ${i === 1 ? "border-l border-black/10 md:border-l-0" : ""} ${i === 3 ? "border-l border-black/10" : ""}`}
              data-testid={`stat-${i}`}
            >
              <div className="font-display text-5xl md:text-7xl font-light tracking-[-0.03em] text-black">{s.value}</div>
              <div className="mt-3 text-xs md:text-sm uppercase tracking-[0.24em] text-zinc-500">{s.label}</div>
            </motion.div>
          ))}
        </div>

        <div className="mt-24 md:mt-32">
          <FadeUp><SectionLabel>Milestones</SectionLabel></FadeUp>
          <div className="mt-10 md:mt-14 border-t border-black/10" data-testid="milestones-list">
            {milestones.map((m, i) => (
              <motion.div key={m.year + i}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.8, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                className="group grid grid-cols-12 gap-4 md:gap-8 py-6 md:py-8 border-b border-black/10 items-baseline"
                data-testid={`milestone-${i}`}>
                <div className="col-span-3 md:col-span-2 font-display text-2xl md:text-4xl font-light text-black">{m.year}</div>
                <div className="col-span-9 md:col-span-10 text-zinc-700 text-base md:text-2xl font-light leading-snug">{m.title}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
